import { useState } from 'react';
import ProductRequestModal from '../../../components/feature/ProductRequestModal';
import Button from '../../../components/base/Button';

export default function ProductsSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const categories = [
    {
      title: 'Premium Wines',
      description: 'Exquisite collection of local and international wines',
      image: 'https://public.readdy.ai/ai/img_res/4659f2989c81970017395fef13899bde.jpg',
      items: ['Red Wines', 'White Wines', 'Rosé Wines', 'Sparkling Wines', 'Dessert Wines'],
      link: '/premium-wines'
    },
    {
      title: 'Fine Spirits',
      description: 'Premium whiskeys, cognacs, and international spirits',
      image: 'https://readdy.ai/api/search-image?query=Premium%20spirits%20collection%20featuring%20whiskey%20bottles%2C%20cognac%2C%20vodka%2C%20gin%2C%20and%20rum%20arranged%20on%20dark%20wooden%20surface%20with%20crystal%20glasses%2C%20luxury%20bar%20setting%20with%20golden%20lighting%20and%20sophisticated%20atmosphere&width=600&height=400&seq=spirits&orientation=landscape',
      items: ['Whiskeys', 'Cognac', 'Vodka', 'Gin', 'Rum'],
      link: '/fine-spirits'
    },
    {
      title: 'Local Beverages',
      description: 'Authentic Ghanaian drinks and traditional beverages',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Ghanaian%20beverages%20and%20local%20drinks%20collection%2C%20palm%20wine%2C%20local%20spirits%2C%20traditional%20bottles%20arranged%20with%20cultural%20elements%2C%20warm%20lighting%20showcasing%20authentic%20African%20beverage%20heritage&width=600&height=400&seq=local&orientation=landscape',
      items: ['Palm Wine', 'Local Spirits', 'Traditional Drinks', 'Herbal Beverages', 'Fruit Wines'],
      link: '/local-beverages'
    },
    {
      title: 'Non-Alcoholic',
      description: 'Premium soft drinks, juices, and refreshing beverages',
      image: 'https://readdy.ai/api/search-image?query=Premium%20non-alcoholic%20beverages%20collection%20with%20fruit%20juices%2C%20soft%20drinks%2C%20sparkling%20water%2C%20energy%20drinks%20arranged%20elegantly%20with%20fresh%20fruits%20and%20ice%2C%20refreshing%20display%20with%20vibrant%20colors&width=600&height=400&seq=nonalcoholic&orientation=landscape',
      items: ['Fruit Juices', 'Soft Drinks', 'Energy Drinks', 'Sparkling Water', 'Health Drinks'],
      link: '/non-alcoholic'
    }
  ];

  const handleViewCollection = (link?: string) => {
    if (link) {
      window.REACT_APP_NAVIGATE(link);
    }
  };

  return (
    <>
      <section id="products" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
              Our <span className="text-yellow-600">Premium Collection</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our extensive range of high-quality beverages, carefully selected from the finest local and international brands
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-product-shop>
            {categories.map((category, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={category.image} 
                    alt={category.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <h3 className="text-2xl font-bold mb-2">{category.title}</h3>
                    <p className="text-gray-200">{category.description}</p>
                  </div>
                </div>
                <div className="p-6">
                  <ul className="space-y-2 mb-6">
                    {category.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-yellow-600 mr-3"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <Button 
                    variant="primary" 
                    className="w-full"
                    onClick={() => handleViewCollection(category.link)}
                  >
                    <i className="ri-eye-line mr-2"></i>
                    View Collection
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <div className="bg-black rounded-2xl p-8 md:p-12 text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">
                Looking for Something Specific?
              </h3>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Can't find what you're looking for? Our expert team can help you source any beverage from our extensive network of suppliers.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  className="font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 px-8 py-4 text-lg "
                >
                  <i className="ri-search-line mr-2"></i>Request Product
                </button>
                <Button variant="outline" size="lg">
                  <i className="ri-phone-line mr-2"></i>
                  Call Us Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ProductRequestModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
